
import React from 'react';
import { Input } from '@/components/ui/input';

interface PhoneInputFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

export const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  id,
  name,
  value,
  onChange,
  required = false
}) => {
  return (
    <Input
      id={id}
      name={name}
      type="tel"
      placeholder="Numéro de téléphone"
      value={value}
      onChange={onChange}
      required={required}
      className="w-full"
    />
  );
};
